import { render } from "./PartnerForm.vue?vue&type=template&id=3a7ac328&scoped=true"
import script from "./PartnerForm.vue?vue&type=script&lang=js"
export * from "./PartnerForm.vue?vue&type=script&lang=js"

import "./PartnerForm.vue?vue&type=style&index=0&id=3a7ac328&scoped=true&lang=css"

import exportComponent from "/vercel/path0/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-3a7ac328"]])

export default __exports__